<template>
  <div class="p-fluid">
    <div class="flex rounded-md border" v-if="selected">
      <div class="flex-1 p-2 box">{{ selected.doc_no_full }} - {{ selected.title }}</div>
      <button class="btn box text-center text-theme-6" @click="delItem"><Trash2Icon class="w-4 h-4 text-center"/></button>
    </div>
    <AutoComplete v-else
      v-model="selected"
      :suggestions="filterOptions"
      @complete="searchOptions($event)"
      @item-select="itemSelect($event)"
      optionGroupLabel="label"
      optionGroupChildren="items"
      dropdown
      :field="selectedField"
      forceSelection
    >
      <template #optiongroup="slotProps">
        <div class="text-white">ข้อมูลของเดือน {{ slotProps.item.label }}</div>
      </template>
      <template #item="slotProps">
        <div>{{ slotProps.item.doc_no_full }} - {{ slotProps.item.title }}</div>
      </template>
    </AutoComplete>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { FilterService, FilterMatchMode } from 'primevue/api'

export default defineComponent({
  name: 'memo-auto-complete',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Number],
      default: () => ''
    }
  },
  emits: ['update:modelValue', 'update:selectedMemo'],
  setup(props, context) {
    const selected = ref()
    const filterOptions = ref()
    const options = ref([])

    const searchOptions = event => {
      // console.log('has: ', options.value.length)
      const query = event.query
      const newFilteredOptions = []

      for (const option of options.value) {
        // console.log('option: ', option)
        const filteredItems = FilterService.filter(
          option.items,
          ['title', 'doc_no_full', 'doc_owner'],
          query,
          FilterMatchMode.CONTAINS
        )
        if (filteredItems && filteredItems.length) {
          newFilteredOptions.push({ ...option, ...{ items: filteredItems } })
        }
      }

      filterOptions.value = newFilteredOptions
    }

    const itemSelect = event => {
      // console.log('event: ', event.value)
      context.emit('update:modelValue', event.value.id)
      context.emit('update:selectedMemo', event.value)
    }

    const delItem = () => {
      selected.value = null
      context.emit('update:modelValue', null)
      context.emit('update:selectedMemo', null)
    }

    watch(
      () => props.options,
      newVal => {
        // console.log('watch: ', newVal)
        options.value = newVal

        if (props.modelValue) {
          for (const n of newVal) {
            const t = FilterService.filter(
              n.items,
              ['id'],
              props.modelValue,
              FilterMatchMode.EQUALS
            )
            if (t && t.length) {
              // console.log('t: ', t)
              selected.value = { ...t[0] }
              context.emit('update:selectedMemo', selected.value)
              return false
            }
          }
        }
      },
      {
        immediate: true
      }
    )

    const selectedField = e => {
      // console.log('e: ', e)
      return `${e.doc_no_full} - ${e.title}`
    }

    return {
      selected,
      filterOptions,
      searchOptions,
      selectedField,
      itemSelect,
      delItem
    }
  }
})
</script>
